import { Dispatch } from 'redux';

export type NotificationsState = {
  notificationDataList: NotificationData[];
  hasCopiedTemplate?: boolean; // This is used to refresh the TemplateList
  hasCompletedPdsNotification?: boolean; // This is used to refresh the DataSourceList
  deleteModalOpen: boolean;
  notificationCenterOpen: boolean;
  isLoading: boolean;
};

export type NotificationData = {
  id: string;
  read: boolean;
  clientId: string;
  userId: string;
  link?: NotificationLink;
  completed: boolean;
  ttl?: number;
  text: string;
  smallText: string | null;
  status: number;
  timestamp: Date;
  createdDate: Date;
  notificationType: NotificationType;
  eventUserInfo?: EventUserInfo;
  data?: Record<string, object>;
};

export type EventUserInfo = {
  initiatorId: string;
  initiatedBySystemUser: boolean;
  initiatorName: string;
  initiatorFirstName: string;
  initiatorLastName: string;
  initiatorUsername: string;
  initiatorHasProfilePicture: boolean;
};

export type NotificationLink = {
  resourceId: string;
  resourceType: number;
  text: string;
  url: string;
  status: string;
};

export type NotificationsAction = {
  type: string;
  payload?: Partial<NotificationsPayload>;
};

export type NotificationsPayload = {
  notifications: Partial<NotificationData>[];
  hasCopiedTemplate: boolean;
  deleteModalOpen: boolean;
  notificationCenterOpen: boolean;
  hasCompletedPdsNotification: boolean;
  isLoading: boolean;
};

export type MenuIndex = 0 | 1;

export type NotificationMenuItem = {
  name: 'All' | 'Unread';
  index: MenuIndex;
};

export type ActionMenuType = {
  name: 'Bulk' | 'Single';
};

export type NotificationsDispatch = Dispatch<NotificationsAction>;

export enum NotificationType {
  FormTemplateVersionUpdated,
  FormTransfer,
  FormTransferComment
}
